export enum LoginStatusMode {
    OK,
    INCORRECT_CREDENTIALS,
    VERIFY_IP,
    ACCOUNT_BLOCKED,
}
